// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"321":"5658ad9b395ba650","650":"6403e6e89d16f7a7","908":"821ad9ae4c0420ea"}[chunkId] + ".js";
};